import React from 'react'
import './spinner.scss'

const Spinner = () => {
  return (
    <div className="flex-grow-1">
      <div className="loader"></div>
    </div>
  )
}

export default Spinner
